import { render, staticRenderFns } from "./DriverTicketQuickView.vue?vue&type=template&id=81582614&scoped=true&"
import script from "./DriverTicketQuickView.vue?vue&type=script&lang=js&"
export * from "./DriverTicketQuickView.vue?vue&type=script&lang=js&"
import style0 from "./DriverTicketQuickView.vue?vue&type=style&index=0&id=81582614&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81582614",
  null
  
)

export default component.exports